import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { ModalidadI } from "interfaces/Modalidad";
import { Dropdown } from "react-bootstrap";
import { deleteModalidad } from "services/modalidad";

interface Props {
  elemento: ModalidadI;
  onClickEdit: (elemento: ModalidadI) => void;
  refreshTable: () => void;
}

export const ModalidadRowActions = ({
  elemento,
  onClickEdit,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteModalidad(id);
      showSuccessToast("¡La modalidad fue eliminado con éxito!");
      refreshTable();
    } catch (error:any) {
      showErrorToast("Error eliminando la modalidad: ", error.message);
    }
  };

  // const onClickVerDocumento = (id: string | number) => {
  //     openFile({ id })
  // }

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar modalidad"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar la Modalidad {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
